var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNonDemand = function SvgNonDemand(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    fillRule: "evenodd",
    d: "M12.25 3.56h-4.5a.25.25 0 0 0-.25.249v1.244h5V3.81a.25.25 0 0 0-.25-.249M6 5.053V3.81c0-.961.784-1.742 1.75-1.742h4.5c.966 0 1.75.78 1.75 1.742v1.244h2c1.103 0 2 .893 2 1.991v7.965A1.997 1.997 0 0 1 16 17H4c-1.103 0-2-.893-2-1.991V7.044c0-1.098.897-1.99 2-1.99zm7.338 2.943a.49.49 0 0 0-.69 0l-2.581 2.58-2.58-2.58a.488.488 0 0 0-.69.689l2.58 2.58-2.582 2.58a.488.488 0 0 0 .69.69l2.582-2.579 2.58 2.581a.488.488 0 0 0 .69-.69l-2.58-2.581 2.58-2.58c.191-.19.191-.5 0-.69",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNonDemand);
export default ForwardRef;